/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const BellIcon = /*#__PURE__*/ createSvgIcon(
  'BellIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M4.756 15.5a.738.738 0 01-.537-.214.714.714 0 01-.219-.532c0-.21.072-.39.216-.535A.72.72 0 014.75 14H5V9c0-1.208.372-2.27 1.115-3.188C6.858 4.896 7.819 4.327 9 4.104V3c0-.278.097-.514.292-.708A.964.964 0 0110 2c.278 0 .514.097.708.292.195.194.292.43.292.708v1.104c1.18.222 2.142.792 2.885 1.708C14.63 6.73 15 7.793 15 9v5h.25c.213 0 .39.072.534.214a.72.72 0 01.216.532c0 .21-.072.39-.215.535a.72.72 0 01-.535.219H4.756zm5.24 2.5c-.414 0-.767-.147-1.059-.44A1.45 1.45 0 018.5 16.5h3c0 .417-.147.77-.442 1.063A1.456 1.456 0 019.996 18zM6.5 14h7V9c0-.972-.34-1.799-1.02-2.48-.681-.68-1.508-1.02-2.48-1.02s-1.799.34-2.48 1.02C6.84 7.202 6.5 8.029 6.5 9v5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default BellIcon;
